import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Resolve } from '@angular/router';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { environment } from '../environments/environment';

export interface IMessage {
  nome?: string,
  email?: string,
  assunto?:string, 
  mensagem?: string
}

@Injectable()
export class AppService {
  
  private emailUrl = environment.apiUrl;

  constructor(private http: Http) {

  }

  sendEmail(message: IMessage): Observable<IMessage> | any {
    return this.http.post(this.emailUrl, message)
      .map(response => {
        console.log('Email enviado com sucesso', response);
        return response;
      })
      .catch(error => {
        console.log('Houve uma falha na solicitação de serviço', error);
        return Observable.throw(error)
      })
  }
}


// WEBPACK FOOTER //
// C:/xampp/htdocs/corpo-leve-www/www/src/app/app.service.ts